import { Component } from '@angular/core';

@Component({
  selector: 'gz-page-not-found',
  templateUrl: 'page-not-found.component.html',
  styleUrls: ['page-not-found.component.scss']
})

/**
 * PageNotFound component is displayed when an invalid route is used.
 */
export class PageNotFoundComponent {
}
